import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Question, Section} from '../../model/contest/ContestTask';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {
  ContestQuestionDetailsModalComponent,
  QuestionDetailsData
} from '../contest-question-details-modal/contest-question-details-modal.component';
import {debounceTime} from 'rxjs/operators';

@Component({
  selector: 'contest-editor-section',
  templateUrl: './contest-section.component.html',
  styleUrls: ['./contest-section.component.scss']
})
export class ContestSectionComponent implements OnInit {

  @Input() section!: Section;
  @Input() disabled = false;

  @Input() set editAllowed(value: boolean | undefined) {
    this.editMode = value || false;

    if (this.editMode || this.localizeMode) {
      this.nameField.enable();
    } else {
      this.nameField.disable();
    }
  };
  @Input() set localizeAllowed(value: boolean | undefined) {
    this.localizeMode = value || false;

    if (this.editMode || this.localizeMode) {
      this.nameField.enable();
    } else {
      this.nameField.disable();
    }
  };

  @Output() sectionUpdated = new EventEmitter<Section>();
  @Output() delete = new EventEmitter<Section>();

  editMode!: boolean;
  localizeMode = false;

  nameField = new FormControl('', [
    Validators.required, Validators.minLength(2), Validators.maxLength(128)
  ]);

  sectionForm = new FormGroup({
    name: this.nameField,
  });

  constructor(private dialog: MatDialog) {
  }

  ngOnInit(): void {
    this.nameField.setValue(this.section.name);

    this.nameField.valueChanges.pipe(debounceTime(300)).subscribe(value => {
      if (value !== this.section.name) {
        this.section.name = value as string;
        this.sectionUpdated.emit(this.section);
      }
    });
  }

  addQuestion() {
    this.modifyQuestion();
  }

  private modifyQuestion(question?: Question) {
    const data: QuestionDetailsData = {
      question: question,
      localizeMode: this.localizeMode
    };

    this.dialog.open(ContestQuestionDetailsModalComponent, {
      width: '600px',
      disableClose: true,
      data: data
    }).afterClosed().subscribe((result: QuestionDetailsData) => {
      if (result) {
        if (result.question) {
          if (!this.section.questions.includes(result.question)) {
            this.section.questions.push(result.question);
          }
          this.updateQuestionIndexes();
        } else if (result.origQuestion && question) {
          const oldIndex = this.section.questions.indexOf(question);
          if (oldIndex >= 0) this.section.questions[oldIndex] = result.origQuestion;
        }

        this.sectionUpdated.emit(this.section);
      }
    });
  }

  private updateQuestionIndexes() {
    this.section.questions.forEach((question, index) => question.index = index + 1);
  }

  handleQuestionEdit(question: Question) {
    this.modifyQuestion(question);
  }

  handleQuestionDelete(question: Question) {
    const index = this.section.questions.indexOf(question);
    if (index >= 0) {
      this.section.questions.splice(index, 1);
      this.updateQuestionIndexes();

      this.sectionUpdated.emit(this.section);
    }
  }
}
